<template>
	<div :class="logoClass" class="logo-icon-wrap">
		<div v-if="src" :style="logoStyle" class="logo-icon" />
		<SVGIcon v-else icon-name="profile-sidebar/profile" v-bind="iconSize" />
	</div>
</template>

<script>
import { SVGIcon } from '~/components/interface'

export default {
	name: 'LogoIcon',
	components: { SVGIcon },
	props: {
		src: {
			type: String,
			default: ''
		},
		medium: {
			type: Boolean,
			default: false
		},
		large: {
			type: Boolean,
			default: false
		},
		full: {
			type: Boolean,
			default: false
		},
		customSizes: {
			type: Object,
			default: null
		}
	},
	computed: {
		iconSize () {
			const largeSize = {
				width: 100,
				height: 100
			}
			const mediumSize = {
				width: 50,
				height: 50
			}
			const smallSize = {
				width: 28,
				height: 28
			}

			if (this.customSizes) {
				return { width: this.customSizes.width || mediumSize.width, height: this.customSizes.height || mediumSize.height }
			}

			const size = this.medium ? mediumSize : this.large ? largeSize : smallSize

			return size
		},
		logoStyle () {
			return { backgroundImage: `url(${this.src})` }
		},
		logoClass () {
			return {
				'large-icon': this.large,
				'medium-icon': this.medium,
				'full-icon': this.full
			}
		}
	}
}
</script>

<style lang="scss">
	.logo-icon-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 60px;
		width: 60px;
		padding: 0;
		background-color: $white;
		border: 1px solid #c4c4c4;
		border-radius: 50%;

		&.full-icon {
			height: 100%;
			width: 100%;
			border: none;
		}

		&.medium-icon {
			height: 120px;
			width: 120px;
		}

		&.large-icon {
			height: 200px;
			width: 200px;
		}

		.logo-icon {
			width: 100%;
			height: 100%;
			border-radius: 50%;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;
		}
	}
</style>
